import type { CSSProperties } from 'react';
import styled from 'styled-components';
import { primaryBlue } from '../models/colors';

export const List = styled('div')`
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin: 1.5rem 5rem;
`;

export const Item = styled('div')`
	display: flex;
	gap: 1.25rem;
`;

export const ItemText = styled('p')`
	font-size: 1rem;
	font-weight: bold;
	text-align: left;
	color: ${primaryBlue};
	margin: 0px;
`;

export const ListItem = ({ text, textStyle }: { text?: string; textStyle?: CSSProperties }) => (
	<Item>
		<ItemText style={textStyle}>•</ItemText>
		{text ? <ItemText style={textStyle}>{text}</ItemText> : null}
	</Item>
);
